/**
 * 診療メニューの ID。
 *
 * 自費診療の種別と保険診療を識別するために使用される。
 * `domain/index.ts` で `export * as Consultation` 経由で公開されるため、
 * 利用側からは `Consultation.MenuId.Upneeq` のように参照される。
 */
export const MenuId = {
    /** 保険診療 */
    Default: 1,
    /** 自由診療: お子様の近視進行抑制 */
    Private: 2,
    /** 自由診療: 保険証・資格確認書なし */
    NoInsuranceCard: 3,
    /** 自由診療: 後天性眼瞼下垂治療（アップニーク） */
    Upneeq: 4,
};
/**
 * 自費診療として扱うメニュー ID の集合。
 * 保険診療（Default）と区別され、院内処方や送付先住所などの挙動が固定される。
 */
const SELF_PAY_MENU_IDS = [
    MenuId.Private,
    MenuId.NoInsuranceCard,
    MenuId.Upneeq,
];
/**
 * 自費診療メニューかどうかを判定する。
 * `consultationMenuId` が undefined の場合は false（保険診療相当として扱うため）。
 */
export const isSelfPayMenu = (menuId) => menuId !== undefined && SELF_PAY_MENU_IDS.includes(menuId);
/**
 * ORCA 登録のトラッキング（clinic 側の「ORCAへの登録状況」UI）が必要なメニュー ID の集合。
 * 保険診療および Upneeq は ORCA 登録運用の対象。
 * Private / NoInsuranceCard は ORCA 連携対象外。
 */
const ORCA_TRACKING_MENU_IDS = [
    MenuId.Default,
    MenuId.Upneeq,
];
/**
 * ORCA 登録のトラッキング UI を表示すべきメニューかどうかを判定する。
 * `consultationMenuId` が undefined の場合は保険診療相当として扱い、true を返す。
 */
export const requiresOrcaTracking = (menuId) => ORCA_TRACKING_MENU_IDS.includes(menuId ?? MenuId.Default);
